<!-- 添加题目弹窗 -->
<template>
  <el-dialog
    :width="question.type == 7 ? '1700px' : '918px'"
    title="添加题目"
    :visible.sync="visible"
    append-to-body
    :before-close="handleClose"
  >
    <!-- 弹窗内容 -->
    <div>
      <el-form
        class="myForm"
        ref="form"
        :model="question"
        label-width="100px"
        :disabled="onlyShow"
      >
        <el-form-item label="题目类型：" required>
          <el-radio-group v-model="question.type">
            <el-radio :label="1"><span class="r_text">单选题</span></el-radio>
            <el-radio :label="2"><span class="r_text">多选题</span></el-radio>
            <el-radio :label="3"><span class="r_text">填空题</span></el-radio>
            <el-radio :label="4" v-if="isShowPicSingle"
              ><span class="r_text">图片单选题</span></el-radio
            >
            <el-radio :label="5" v-if="isShowMoreSelect"
              ><span class="r_text">图片多选题</span></el-radio
            >
            <el-radio :label="6" v-if="isShowPicUpload"
              ><span class="r_text">图片上传题</span></el-radio
            >
            <el-radio :label="7" v-if="isShowMatrix"
              ><span class="r_text">矩阵题</span></el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="题目名称：" required>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="currentTitle"
            maxlength="50"
            show-word-limit
            class="fixed-size-textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否必填：" required>
          <el-radio-group v-model="currentRequired">
            <el-radio :label="1"><span class="r_text">必填</span></el-radio>
            <el-radio :label="0"><span class="r_text">非必填</span></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选项设置："
          v-if="
            question.type == 1 ||
              question.type == 2 ||
              question.type == 4 ||
              question.type == 5
          "
          required=""
        >
          <!-- 单选题的选项配置 -->
          <div class="optionSetting" v-if="question.type == 1">
            <div
              class="optionS"
              v-for="(item, index) in question.options1"
              :key="item.id"
            >
              <div class="label-width">选项{{ optionTitle(index) }}：</div>
              <el-input
                style="width: 370px"
                type="text"
                placeholder="请输入内容"
                v-model="item.description"
                maxlength="50"
                show-word-limit
              ></el-input>
              <el-button
                v-if="question.options1.length > 2"
                type="text"
                :style="{ color: '#f56c6c' }"
                :disabled="onlyShow"
                @click="deleteOption(question.type, index)"
                >删除</el-button
              >
            </div>
            <el-button
              class="add-btn"
              :disabled="onlyShow"
              @click="addNewOption(question.type)"
              >新增选项（{{ question.options1.length }}/20）</el-button
            >
          </div>
          <!-- 多选题的选项配置 -->
          <div class="optionSetting" v-if="question.type == 2">
            <div
              class="optionS"
              v-for="(item, index) in question.options2"
              :key="item.id"
            >
              <div class="label-width">选项{{ optionTitle(index) }}：</div>
              <el-input
                style="width: 370px"
                type="text"
                placeholder="请输入内容"
                v-model="item.description"
                maxlength="50"
                show-word-limit
              ></el-input>
              <span
                v-if="question.options2.length > 2"
                @click="deleteOption(question.type, index)"
                >删除</span
              >
            </div>
            <el-button class="add-btn" @click="addNewOption(question.type)"
              >新增选项（{{ question.options2.length }}/20）</el-button
            >
          </div>
          <!-- 图片单选题的选项配置 -->
          <div class="optionSetting" v-if="question.type == 4">
            <div
              class="imgOptions"
              v-for="(item, index) in question.options4"
              :key="item.id"
            >
              选项{{ optionTitle(index) }}：
              <el-upload
                class="upload"
                action="/jd-hd-web/image/upload"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-success="
                  (res, file, fileList) =>
                    handleUpload(res, file, fileList, index)
                "
              >
                <div class="img">
                  <img v-if="item.picUrl" :src="item.picUrl" alt="选项图片" />
                  <div
                    v-else
                    style="
                      border-radius: 5px;
                      border: 1px solid #f0f0f0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      width: 70x;
                      height: 70px;
                    "
                  >
                    <i
                      class="el-icon-plus"
                      style="font-size: 30px; color: #f0f0f0"
                    ></i>
                  </div>
                </div>
              </el-upload>
              <div class="dec">
                <div class="dec_text">尺寸建议：200px*200px</div>
                <div class="dec_text">图片大小：2M以内</div>
                <div class="dec_text">支持格式：jpg，png</div>
                <span
                  v-if="question.options4.length > 2"
                  @click="deleteOption(question.type, index)"
                  >删除</span
                >
              </div>
            </div>
            <el-button class="add-btn" @click="addNewOption(question.type)"
              >新增选项（{{ question.options4.length }}/6）</el-button
            >
          </div>
          <!-- 图片多选题的选项配置 -->
          <div class="optionSetting" v-if="question.type == 5">
            <div
              class="imgOptions"
              v-for="(item, index) in question.options5"
              :key="item.id"
            >
              选项{{ optionTitle(index) }}：
              <el-upload
                class="upload"
                action="/jd-hd-web/image/upload"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-success="
                  (res, file, fileList) =>
                    handleUpload(res, file, fileList, index)
                "
              >
                <div class="img">
                  <img v-if="item.picUrl" :src="item.picUrl" alt="选项图片" />
                  <div
                    v-else
                    style="
                      border-radius: 5px;
                      border: 1px solid #f0f0f0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      width: 70x;
                      height: 70px;
                    "
                  >
                    <i
                      class="el-icon-plus"
                      style="font-size: 30px; color: #f0f0f0"
                    ></i>
                  </div>
                </div>
              </el-upload>
              <div class="dec">
                <div class="dec_text">尺寸建议：200px*200px</div>
                <div class="dec_text">图片大小：2M以内</div>
                <div class="dec_text">支持格式：jpg，png</div>
                <span
                  v-if="question.options5.length > 2"
                  @click="deleteOption(question.type, index)"
                  >删除</span
                >
              </div>
            </div>
            <el-button class="add-btn" @click="addNewOption(question.type)"
              >新增选项（{{ question.options5.length }}/6）</el-button
            >
          </div>
        </el-form-item>
        <!-- 填空题 -->
        <el-form-item label="字数限制：" v-if="question.type == 3" required>
          <div class="limited">
            不少于
            <el-input
              style="width: 100px"
              type="text"
              placeholder="请输入"
              v-model="question.textLimit"
              show-word-limit
              @input="limitInput"
            ></el-input>
            个字，最多200个字
          </div>
        </el-form-item>
        <!-- 图片上传题 -->
        <el-form-item label="上传张数：" v-if="question.type == 6" required>
          <div class="limited">
            不少于
            <el-input
              style="width: 100px"
              type="text"
              placeholder="请输入"
              v-model="question.picLimit"
              show-word-limit
              @input="limitPicUp"
            ></el-input>
            张，最多5张
          </div>
        </el-form-item>

        <!-- 矩阵题 -->
        <el-form-item label="选项设置：" v-if="question.type == 7" required>
          <div class="optionSetting">
            <div class="option-table-list">
              <div class="table-header">
                <template v-for="(cItem, cIndex) in options10Column">
                  <div class="header-column-item" v-if="cIndex == 0">
                    题目\选项
                  </div>
                  <div class="header-column-item" v-else>
                    <el-input
                      style="width: 220px"
                      type="text"
                      placeholder="请输入(12字内)"
                      v-model="cItem.columnDescription"
                      maxlength="12"
                      show-word-limit
                    ></el-input>
                  </div>
                </template>
                <div class="header-column-item-control">
                  <el-button
                    class="add-btn1"
                    @click="addColumnOrRowOption('column')"
                    >新增列（{{ options10Column.length - 1 }}/5）</el-button
                  >
                </div>
              </div>
              <div class="table-body">
                <div class="table-row">
                  <div
                    class="table-row-item"
                    v-for="(rItem, rIndex) in options10Row"
                  >
                    <template v-for="(cItem, cIndex) in options10Column">
                      <div class="row-column-item" v-if="cIndex == 0">
                        <el-input
                          style="width: 220px"
                          type="text"
                          placeholder="请输入(12字内)"
                          v-model="rItem.rowDescription"
                          maxlength="12"
                          show-word-limit
                        ></el-input>
                      </div>
                      <div class="row-column-item radio-item" v-else>
                        <div class="rc-item-radio"></div>
                      </div>
                    </template>
                    <div class="row-column-item-control fstart">
                      <span @click="deleteColumnOrRowOption('row', rIndex)"
                        ><i
                          :class="[
                            'el-icon-delete',
                            'del-icon',
                            options10Row.length <= 2 ? 'disabled' : '',
                          ]"
                        ></i
                      ></span>
                    </div>
                  </div>
                  <div class="table-row-item-control">
                    <div
                      :class="['row-item-control', cIndex == 0 ? 'fstart' : '']"
                      v-for="(cItem, cIndex) in options10Column"
                    >
                      <el-button
                        class="add-btn1"
                        @click="addColumnOrRowOption('row')"
                        v-if="cIndex == 0"
                        >新增行（{{ options10Row.length }}/20）</el-button
                      >
                      <span
                        @click="deleteColumnOrRowOption('column', cIndex)"
                        v-else
                        ><i
                          :class="[
                            'el-icon-delete',
                            'del-icon',
                            options10Column.length <= 3 ? 'disabled' : '',
                          ]"
                        ></i
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 弹窗底部操作按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" v-if="!onlyShow" @click="handleConfirm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
// 题目类型 1单选题 2多选题 3填空题 4图片选择题 5图片多选题 6图片上传题
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 接收要修改的数据
    currentQuestion: {},
    isEdit: {
      type: Boolean,
      default: false,
    },
    // 仅查看
    onlyShow: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    // 是否显示矩阵题
    isShowMatrix: {
      from: "isShowMatrix",
      default: true, // 设置默认值
    },
    // 是否显示图片多选题
    isShowMoreSelect: {
      from: "isShowMoreSelect",
      default: true, // 设置默认值
    },
    // 是否显示图片单选题
    isShowPicSingle: {
      from: "isShowPictureSingle",
      default: true, // 设置默认值
    },
    // 是否显示图片上传题
    isShowPicUpload: {
      from: "isShowPicUpload",
      default: true, // 设置默认值
    },
  },
  data() {
    return {
      question: {
        type: 1,
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        title5: "",
        title6: "",
        title7: "",
        isMust1: 1,
        isMust2: 1,
        isMust3: 1,
        isMust4: 1,
        isMust5: 1,
        isMust6: 1,
        isMust7: 1,
        options1: [
          { description: "" },
          { description: "" },
          { description: "" },
        ],
        options2: [
          { description: "" },
          { description: "" },
          { description: "" },
          { description: "" },
        ],
        options4: [{ picUrl: null }, { picUrl: null }, { picUrl: null }],
        options5: [
          { picUrl: null },
          { picUrl: null },
          { picUrl: null },
          { picUrl: null },
        ],
        textLimit: "",
        picLimit: "",
      },
      options10Column: [
        { columnDescription: "" },
        { columnDescription: "" },
        { columnDescription: "" },
        { columnDescription: "" },
      ],
      options10Row: [{ rowDescription: "" }, { rowDescription: "" }],
    };
  },
  computed: {
    currentTitle: {
      get() {
        const type = parseInt(this.question.type);
        return this.question[`title${type}`];
      },
      set(value) {
        const type = parseInt(this.question.type);
        this.question[`title${type}`] = value;
      },
    },
    currentRequired: {
      get() {
        const type = parseInt(this.question.type);
        return this.question[`isMust${type}`];
      },
      set(value) {
        const type = parseInt(this.question.type);
        this.question[`isMust${type}`] = value;
      },
    },
  },
  watch: {
    visible(value) {
      if (this.isEdit || this.onlyShow) {
        // 修改问题的回显
        this.resetQuestion();
        let q = this.currentQuestion;
        let type = Number(q.type);
        console.log("-子currentQuestion-- q:---", q);
        let data = { type };
        data[`isMust${type}`] = Number(q.isMust);
        data[`title${type}`] = q.title;
        if (type == 1 || type == 2 || type == 4 || type == 5) {
          data[`options${type}`] = q.options;
        }
        if (type == 3) {
          data.textLimit = q.textLimit;
        }
        if (type == 6) {
          data.picLimit = Number(q.picLimit);
        }
        //矩阵类型
        if (type == 7) {
          let qOptions = q.options || [];
          let options10Row = [];
          let options10Column = [];
          qOptions.forEach((item) => {
            let options10RowSort = options10Row.map((item1) => item1.sort);
            let options10ColumnLevel = options10Column.map(
              (item2) => item2.level
            );
            if (!options10RowSort.includes(item.sort)) {
              let rowObj = {
                rowDescription: item.description.split(":")[0],
                ...item,
              };
              options10Row.push(rowObj);
            }
            if (!options10ColumnLevel.includes(item.level)) {
              let colObj = {
                columnDescription: item.description.split(":")[1],
                ...item,
              };
              options10Column.push(colObj);
            }
          });
          this.options10Row = options10Row.sort(function(a, b) {
            return a.sort - b.sort;
          });
          options10Column.unshift({ columnDescription: "" });
          this.options10Column = options10Column;
        }
        this.question = {
          ...this.question,
          ...JSON.parse(JSON.stringify(data)),
        };
        console.log("--- this.question:---", this.question);
      } else {
        this.resetQuestion();
      }
    },
  },
  methods: {
    /**flag row行 column列 */
    addColumnOrRowOption(flag) {
      if (flag == "row") {
        if (this.options10Row.length >= 20) return;
        this.options10Row.push({ rowDescription: "" });
      } else if (flag == "column") {
        if (this.options10Column.length >= 6) return;
        this.options10Column.push({ columnDescription: "" });
      }
      console.log("options10Row", this.options10Row);
      console.log("options10Column", this.options10Column);
    },
    deleteColumnOrRowOption(flag, index) {
      if (flag == "row") {
        if (this.options10Row.length <= 2) return;
        this.options10Row.splice(index, 1);
      } else if (flag == "column") {
        if (this.options10Column.length <= 3) return;
        this.options10Column.splice(index, 1);
      }
    },
    // 新增选项
    addNewOption(type) {
      if (type == 1) {
        if (this.question.options1.length < 20) {
          this.question.options1.push({ description: "" });
        }
      } else if (type == 2) {
        if (this.question.options2.length < 20) {
          this.question.options2.push({ description: "" });
        }
      } else if (type == 4) {
        if (this.question.options4.length < 6) {
          this.question.options4.push({ picUrl: null });
        }
      } else if (type == 5) {
        if (this.question.options5.length < 6) {
          this.question.options5.push({ picUrl: null });
        }
      }
    },
    // 删除选项
    deleteOption(type, index) {
      if (type == 1) {
        this.question.options1.splice(index, 1);
      } else if (type == 2) {
        this.question.options2.splice(index, 1);
      } else if (type == 4) {
        this.question.options4.splice(index, 1);
      } else if (type == 5) {
        this.question.options5.splice(index, 1);
      }
    },
    // 根据 index获取选项名称
    optionTitle(index) {
      switch (index) {
        case 0:
          return "A";
        case 1:
          return "B";
        case 2:
          return "C";
        case 3:
          return "D";
        case 4:
          return "E";
        case 5:
          return "F";
        case 6:
          return "G";
        case 7:
          return "H";
        case 8:
          return "I";
        case 9:
          return "J";
        case 10:
          return "K";
        case 11:
          return "L";
        case 12:
          return "M";
        case 13:
          return "N";
        case 14:
          return "O";
        case 15:
          return "P";
        case 16:
          return "Q";
        case 17:
          return "R";
        case 18:
          return "S";
        case 19:
          return "T";
        default:
          return "";
      }
    },
    // 填空题字数限制
    limitInput(value) {
      const regex = /^(?:[1-9]|[1-9]\d|1\d{2}|200)$/;
      if (!regex.test(value)) {
        this.question.textLimit = this.question.textLimit.replace(/[^\d]/g, "");
        if (this.question.textLimit > 200) {
          this.question.textLimit = 200;
        }
        if (this.question.textLimit < 1) {
          this.question.textLimit = "";
        }
      }
    },
    // 图片上传张数限制
    limitPicUp(value) {
      const regex = /^[1-5]$/;
      if (!regex.test(value)) {
        this.question.picLimit = this.question.picLimit.replace(/[^\d]/g, "");
        if (this.question.picLimit > 5) {
          this.question.picLimit = 5;
        }
        if (this.question.picLimit < 1) {
          this.question.picLimit = "";
        }
      }
    },
    async beforeUpload(file) {
      // 图片上传前的校验
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      // await this.imgchecked(file, 300, 300);
      // console.log(file);
      // const isLt3M = file.size < 1024 * 100;
      // if (!isLt3M) {
      //   this.$message.info("图片大小不符合要求，请重新上传");
      //   await Promise.reject();
      //   return false;
      // }
    },
    handleUpload(res, file, fileList, index) {
      if (res.code != 1) {
        this.$message.error(res.message || "上传失败");
      } else {
        console.log("---  res:---", res);
        // 直接更新指定索引的选项
        const imageUrl = res.data;
        if (this.question.type == 5) {
          this.$set(this.question.options5[index], "picUrl", imageUrl);
          return;
        }
        if (imageUrl) {
          this.$set(this.question.options4[index], "picUrl", imageUrl);
        }
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
      this.$emit("reset-only-show");
      this.resetQuestion();
    },
    // 确认操作
    handleConfirm() {
      let data = { type: Number(this.question.type) };
      let type = parseInt(this.question.type);
      data.isMust = Number(this.question[`isMust${type}`]);
      data.title = this.question[`title${type}`];
      if (!data.title) {
        this.$message.warning("题目名称不能为空");
        return;
      }
      if (type == 1 || type == 2) {
        const options = this.question[`options${type}`];
        const emptyOption = options.find((item) => !item.description);
        if (emptyOption) {
          this.$message.warning("选项内容不能为空");
          return;
        }
        data.options = options;
      }
      if (type == 3) {
        if (data.isMust === 1 && !this.question.textLimit) {
          this.$message.warning("字数限制不能为空");
          return;
        }
        data.textLimit = this.question.textLimit;
      }
      if (type == 4) {
        const options = this.question[`options${type}`];
        const emptyOption = options.find((item) => !item.picUrl);
        if (emptyOption) {
          this.$message.warning("图片不能为空");
          return;
        }
        data.options = options;
      }
      if (type == 5) {
        const options = this.question[`options${type}`];
        const emptyOption = options.find((item) => !item.picUrl);
        if (emptyOption) {
          this.$message.warning("图片不能为空");
          return;
        }
        data.options = options;
      }
      if (type == 6) {
        if (data.isMust === 1 && !this.question.picLimit) {
          this.$message.warning("上传张数不能为空");
          return;
        }
        data.picLimit = Number(this.question.picLimit);
      }

      if (type == 7) {
        let hasColumnEmpty = this.options10Column
          .slice(1)
          .some((item) => !item.columnDescription);
        let hasRowEmpty = this.options10Row.some(
          (item) => !item.rowDescription
        );
        if (hasColumnEmpty || hasRowEmpty) {
          this.$message.warning("请完善选项设置");
          return;
        }

        let optionsRow = this.options10Row;
        let optionsColumn = this.options10Column.slice(1);
        let options = [];
        let colLevelMap = {
          0: "A",
          1: "B",
          2: "C",
          3: "D",
          4: "E",
          5: "F",
        };
        optionsRow.forEach((rowItem, rowIndex) => {
          optionsColumn.forEach((colItem, colIndex) => {
            let optObj = {
              description: `${rowItem.rowDescription}:${colItem.columnDescription}`,
              sort: rowIndex,
              level: colLevelMap[colIndex],
            };
            options.push(optObj);
          });
        });
        data.options = options;
        // data.optionsRow = this.options10Row
        // data.optionsColumn = this.options10Column.slice(1)
      }
      console.log("data>>", data);

      this.$emit("confirm", data);
      this.handleClose();
    },
    // 重置 question
    resetQuestion() {
      this.question = {
        type: 1,
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        title5: "",
        title6: "",
        title7: "",
        isMust1: 1,
        isMust2: 1,
        isMust3: 1,
        isMust4: 1,
        isMust5: 1,
        isMust6: 1,
        isMust7: 1,
        options1: [
          { description: "" },
          { description: "" },
          { description: "" },
        ],
        options2: [
          { description: "" },
          { description: "" },
          { description: "" },
          { description: "" },
        ],
        options4: [{ picUrl: null }, { picUrl: null }, { picUrl: null }],
        options5: [
          { picUrl: null },
          { picUrl: null },
          { picUrl: null },
          { picUrl: null },
        ],
        textLimit: "",
        picLimit: "",
      };
      this.options10Column = [
        { columnDescription: "" },
        { columnDescription: "" },
        { columnDescription: "" },
        { columnDescription: "" },
      ];
      this.options10Row = [{ rowDescription: "" }, { rowDescription: "" }];
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog .el-dialog__title) {
  color: #212533 !important;
  font-weight: normal !important;
}

:deep(.myButton.el-button.el-button--default.el-button--small) {
  color: #666666 !important;
}

:deep(.myButton.el-button.el-button--primary.el-button--small) {
  background-color: #3159ff !important;
  border-color: transparent !important;

  &:hover {
    background-color: #315affc2 !important;
  }
}

:deep(.fixed-size-textarea .el-textarea__inner) {
  width: 471px;
  height: 94px;
  resize: none;
}

:deep(.el-textarea) {
  width: 471px;
  font-size: 14px;
  color: #666666;
}

.dialog-footer {
  text-align: right;
}

.myForm {
  color: #666666;

  .r_text {
    color: #333333;
    margin-left: 8px;
  }

  .optionSetting {
    width: 100%;
    background-color: #f8f9fc;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .optionS {
      display: flex;
      align-items: center;
      gap: 8px;

      .label-width {
        width: 60px;
        text-align: right;
      }

      span {
        color: #3159ff;
        margin-left: 12px;
        cursor: pointer;
      }

      .hidden {
        color: rgba(49, 89, 255, 0.8);
        cursor: not-allowed;
      }
    }

    .imgOptions {
      display: flex;

      .img {
        width: 70px;
        height: 70px;
        margin: 0 12px 0 8px;

        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }

      .dec {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;

        .dec_text {
          line-height: 17px;
          font-size: 12px;
          color: #999;
        }

        span {
          color: #3159ff;
          cursor: pointer;
          line-height: 18px;
        }

        .hidden {
          color: rgba(49, 89, 255, 0.8);
          cursor: not-allowed;
        }
      }
    }
  }

  .limited {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .option-table-list {
    .fstart {
      display: flex;
      justify-content: flex-start !important;
    }
    .del-icon {
      color: #666;
      cursor: pointer;
      font-size: 20px;
    }
    .del-icon.disabled {
      color: #999;
      cursor: not-allowed;
    }
    .table-header {
      display: flex;
      .header-column-item {
        width: 230px;
        height: 52px;
        background: #f0f2f7;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
        &:nth-last-child(1) {
          border: none;
        }
        /deep/ .el-input--small .el-input__inner {
          padding: 10px !important;
          background: #fff !important;
          border: 1px solid #dcdfe6 !important;
        }
        /deep/ .el-input__count-inner {
          background: transparent !important;
        }
      }
      .header-column-item-control {
        width: 122px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 11px;
      }
    }
    .table-body {
      .table-row {
        .table-row-item {
          display: flex;
        }
        .row-column-item {
          width: 230px;
          height: 52px;
          background: #f0f2f7;
          border-radius: 0px 0px 0px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #eeeeee;
          border-bottom: 1px solid #eeeeee;
          &:nth-last-child(1) {
            border: none;
          }
          /deep/ .el-input--small .el-input__inner {
            padding: 10px !important;
            background: #fff !important;
            border: 1px solid #dcdfe6 !important;
          }
          /deep/ .el-input__count-inner {
            background: transparent !important;
          }
        }
        .row-column-item.radio-item {
          background: #ffffff;
        }
        .row-column-item .rc-item-radio {
          width: 16px;
          height: 16px;
          background: #ffffff;
          border-radius: 100px 100px 100px 100px;
          border: 1px solid #d9d9d9;
        }

        .table-row-item-control {
          display: flex;
          .row-item-control {
            width: 230px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .row-column-item-control {
          width: 122px;
          height: 52px;
          display: flex;
          margin-left: 11px;
        }
      }
    }
  }
}

.add-btn {
  align-self: flex-start;
  flex-shrink: 0;
  width: auto;
}
.add-btn1 {
  width: auto;
}
</style>
